var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsVinNumberDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 60,
    viewBox: "0 0 38 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.895 0C37.895 1.744 36.482 3.157 34.738 3.157H7.893C5.283 3.157 3.157 5.284 3.157 7.897C3.157 10.507 5.284 12.633 7.893 12.633H37.895V60H6.315C2.83 60 0 57.17 0 53.682V7.897C0 3.597 3.453 0 7.893 0H37.895ZM3.157 14.19V53.682C3.157 55.423 4.574 56.839 6.315 56.839H34.738V15.79H7.893C6.121 15.79 4.481 15.189 3.157 14.19ZM25.263 31.579V34.736H12.63V31.58H25.263V31.579ZM28.42 25.264V28.418H9.473V25.264H28.42ZM37.895 6.316V9.474H7.894C7.024 9.474 6.315 8.767 6.315 7.895C6.315 7.023 7.025 6.316 7.894 6.316H37.895Z",
    fill: "#0562D2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7395_27480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.895 0C37.895 1.744 36.482 3.157 34.738 3.157H7.893C5.283 3.157 3.157 5.284 3.157 7.897C3.157 10.507 5.284 12.633 7.893 12.633H37.895V60H6.315C2.83 60 0 57.17 0 53.682V7.897C0 3.597 3.453 0 7.893 0H37.895ZM3.157 14.19V53.682C3.157 55.423 4.574 56.839 6.315 56.839H34.738V15.79H7.893C6.121 15.79 4.481 15.189 3.157 14.19ZM25.263 31.579V34.736H12.63V31.58H25.263V31.579ZM28.42 25.264V28.418H9.473V25.264H28.42ZM37.895 6.316V9.474H7.894C7.024 9.474 6.315 8.767 6.315 7.895C6.315 7.023 7.025 6.316 7.894 6.316H37.895Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7395_27480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-13 -2H51V62H-13V-2Z",
    fill: "#0562D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVinNumberDocumentation);
export default __webpack_public_path__ + "static/media/icons-vin-number-documentation.61d8eedfbe8dbf29a9c3f23e7a43a85f.svg";
export { ForwardRef as ReactComponent };